import { Skeleton } from '@immo/ui-kit';
import { LANDIQ_BOARD_COLUMNS } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';
import { BOARD_GRID_CLASS } from '@/components/landiq/board/landiq-board';

const PLACEHOLDER_CARDS = [0, 1] as const;

/** The five real column names at once; LandIQ's cards replace the placeholders when it answers. */
export function BoardSkeleton() {
  const t = useTranslations('pages.admin.landiq-data-runs');

  return (
    <div className="h-full min-h-0 overflow-auto bg-canvas p-6">
      <div role="group" aria-label={t('title')} aria-busy="true" className={BOARD_GRID_CLASS}>
        {LANDIQ_BOARD_COLUMNS.map((column) => (
          <section key={column} className="flex min-w-0 flex-col gap-2 rounded-md bg-canvas p-2">
            <h2 className="flex items-center gap-2 text-base-sm font-semibold text-text-primary">
              {t(`board.columns.${column}`)}
              <Skeleton className="h-5 w-6 rounded-pill" />
            </h2>
            {PLACEHOLDER_CARDS.map((card) => (
              <div key={card} className="flex flex-col gap-2 rounded-lg border border-border bg-surface p-3 shadow-sm">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-5 w-20 rounded-pill" />
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
